import { userStore } from "@/mobx/rootStore";

export async function afterLogin() {
	await userStore.init();
}
